import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Modal that appears when a new app version is detected
 * Prompts users to refresh to prevent working on stale data
 */
const VersionUpdateBanner = ({ onRefresh, onDismiss }) => {
  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      style={{ zIndex: 9999 }}
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden animate-in fade-in zoom-in duration-300">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-500 to-amber-500 px-6 py-4">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 rounded-full p-2">
              <AlertTriangle className="h-6 w-6 text-white" />
            </div>
            <h2 className="text-xl font-bold text-white">Update Available</h2>
          </div>
        </div>
        
        {/* Content */}
        <div className="px-6 py-5">
          <p className="text-gray-700 text-base mb-2">
            A new version of the app has been deployed.
          </p>
          <p className="text-gray-600 text-sm mb-6">
            Please refresh to get the latest version and avoid any data loss or errors.
          </p>
          
          {/* Buttons */}
          <div className="flex flex-col gap-3">
            <Button
              onClick={onRefresh}
              className="w-full bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-semibold py-3 h-auto text-base"
            >
              <RefreshCw className="h-5 w-5 mr-2" />
              Refresh Now
            </Button>
            <button
              onClick={onDismiss}
              className="w-full text-gray-500 hover:text-gray-700 text-sm py-2 transition-colors"
            >
              Continue without refreshing (not recommended)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionUpdateBanner;
